export const CHANNEL_TALK_BOOT_OPTIONS = {
  pluginKey: "1d3199b9-855d-4458-a7fc-bb4c28f45383",
  // Stack the ChannelIO messenger above the fixed top header (containers/Header = z-index 9999)
  // and the custom launcher button (ChannelTalkLauncher = 10000) so an open messenger is fully
  // visible at the top of the page instead of being covered by the nav. Kept below app modals
  // (Popup/OwnerShip ~10400+) so dialogs still render on top.
  zIndex: 10001,
  hideChannelButtonOnBoot: true,
};
